<template>
  <div
    id="js-hamburger"
    class="c-hamburger"
    :class="{ _changedColor: isChangedColor, _show: isMenuShow }"
  >
    <button class="c-hamburger__button" @click="clickButton">
      <span class="top" />
      <span class="middle" />
      <span class="bottom" />
      <span class="text u-uppercase" lang="en" v-text="text" />
    </button>
  </div>
</template>

<script>
export default {
  name: 'Hamburger',
  data() {
    return {
      isChangedColor: false,
      isMenuShow: false,
      windowHeight: '',
    };
  },
  computed: {
    text() {
      return this.isMenuShow ? 'Close' : 'Menu';
    },
  },
  mounted() {
    this.scrollFunc();
    this.fixPosition();

    window.addEventListener('scroll', () => {
      this.fixPosition();
    });
  },
  methods: {
    scrollFunc() {
      window.addEventListener('scroll', () => {
        const header = document.getElementById('js-header');
        const headerHeight = header.clientHeight;
        const windowScroll = window.scrollY || window.pageYOffset;

        this.isChangedColor = windowScroll > headerHeight;
      });
    },
    clickButton() {
      this.isMenuShow = !this.isMenuShow;
      this.$emit('hamburger-clicked');

      if (this.isMenuShow) {
        this.addClassBody();
      } else {
        this.removeClassBody();
      }
    },
    fixPosition() {
      const header = document.getElementById('js-header');
      if (header.classList.contains('_hamburgerFixed')) {
        document.getElementById(
          'js-hamburger',
        ).style.left = `-${window.pageXOffset}px`;
      }
    },
    addClassBody() {
      const body = document.querySelector('body');
      this.windowHeight = window.scrollY || window.pageYOffset;
      body.style.top = `-${this.windowHeight}px`;
      body.classList.add('_fixed');
    },
    removeClassBody() {
      const body = document.querySelector('body');
      body.style.top = '';
      body.classList.remove('_fixed');
      window.scrollTo(0, this.windowHeight);
    },
  },
};
</script>
